import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { USER_SETTING_STEPS_ENUM } from 'types/core/systemTypes';
import { PromoterFullInfoType } from 'types/promoters/promoterTypes';

export const SLICE_NAME = 'systemSlice';

export type SystemSliceType = {
  openedSider: boolean;
  userSettingStep: USER_SETTING_STEPS_ENUM;
  activePromoter?: PromoterFullInfoType;
  editingPromoter: boolean;
  serviceViewType?: string;
};

const initialState: SystemSliceType = {
  openedSider: false,
  userSettingStep: USER_SETTING_STEPS_ENUM.ORGANISER_DETAILS,
  activePromoter: undefined,
  editingPromoter: false,
};

export const systemSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setOpenedSider: (state, action: PayloadAction<boolean>) => {
      state.openedSider = action.payload;
    },
    setServiceViewType: (state, action: PayloadAction<string>) => {
      state.serviceViewType = action.payload;
    },
    setUserSettingStep: (state, action: PayloadAction<USER_SETTING_STEPS_ENUM>) => {
      state.userSettingStep = action.payload;
    },
    setActivePromoterFullInfo: (state, action: PayloadAction<PromoterFullInfoType | undefined>) => {
      state.activePromoter = action.payload;
    },
    setEditingPromoter: (state, action: PayloadAction<boolean>) => {
      state.editingPromoter = action.payload;
    },
  },
});

export const {
  setOpenedSider,
  setServiceViewType,
  setActivePromoterFullInfo,
  setEditingPromoter,
  setUserSettingStep,
} = systemSlice.actions;

export default systemSlice.reducer;
